export default {
	pending: 0,
	confirmed: 1,
	approved: 2,
	shipped: 3,
	delivered: 4,
	cancelled: 5
}